import { render, staticRenderFns } from "./AscNote.vue?vue&type=template&id=5daee464&"
import script from "./AscNote.vue?vue&type=script&lang=js&"
export * from "./AscNote.vue?vue&type=script&lang=js&"
import style0 from "./AscNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports